<script>
import gridBinds from '@/mixins/tournaments/gridBinds';

export default {
  name: 'JoinerCard',
  functional: true,
  render(h, { props, data }) {
    const { fromBind, toBind, offset } = props;

    return h('div', {
      ...data,
      class: [...data.class, gridBinds.methods.getClasses(fromBind, toBind)],
      style: { ...data.style, ...gridBinds.methods.getOffset(offset) },
    });
  },
};
</script>
